import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import Spacer from './Spacer';
import PostCard from './PostCard';

const MoreContent = (props) => {
  const {
    posts,
    more_content_headline: moreContentHeadline,
    cta_heading: ctaHeading,
    cta_body: ctaBody,
    cta_link: { title: ctaLinkTitle, url: ctaLinkUrl, target: ctaLinkTarget },
    consumer_headline: consumerHeadline,
    consumer_heading: consumerHeading,
    consumer_body: consumerBody,
    consumer_link: {
      title: consumerLinkTitle,
      url: consumerLinkUrl,
      target: consumerLinkTarget,
    },
    professional_headline: professionalHeadline,
    professional_heading: professionalHeading,
    professional_body: professionalBody,
    professional_link: {
      title: professionalLinkTitle,
      url: professionalLinkUrl,
      target: professionalLinkTarget,
    },
  } = props;

  return (
    <div className="more">
      <Row>
        <Col
          xs={{
            offset: 0,
            span: 24,
          }}
          md={{ offset: 0, span: 16 }}
          className="more__left"
        >
          <Spacer size="md" />
          <div className="more__posts">
            <h2 className="more__posts-headline">{moreContentHeadline}</h2>
            <Spacer size="md" />
            <Row gutter={40}>
              {posts.map((post) => (
                <Col
                  key={post.title}
                  xs={{ offset: 0, span: 24 }}
                  sm={{ offset: 0, span: 12 }}
                >
                  <PostCard post={post} />
                </Col>
              ))}
            </Row>
          </div>
          <Spacer size="md" />
          <div className="more__cta">
            <Spacer size="md" />
            <h2 className="more__cta-headline">{ctaHeading}</h2>
            <Spacer size="sm" />
            <p className="more__cta-body">{ctaBody}</p>
            <Spacer size="sm" />
            <div className="more__cta-button">
              <a
                target={ctaLinkTarget}
                className="button large dark-green"
                href={ctaLinkUrl}
              >
                {ctaLinkTitle}
              </a>
            </div>
            <Spacer size="md" />
          </div>
          <Spacer size="md" />
        </Col>
        <Col
          xs={{
            offset: 0,
            span: 24,
          }}
          md={{ offset: 0, span: 8 }}
          className="more__right"
        >
          <Row style={{ height: '100%' }}>
            <Col
              xs={{
                offset: 0,
                span: 24,
              }}
              sm={{ offset: 0, span: 12 }}
              md={{
                offset: 0,
                span: 24,
              }}
              className="more__customer more__customer--consumer"
            >
              <Spacer size="md" />
              <h2 className="more__customer-headline">{consumerHeadline}</h2>
              <Spacer size="md" />
              <h3 className="more__customer-heading">{consumerHeading}</h3>
              <Spacer size="sm" />
              <p className="more__customer-body">{consumerBody}</p>
              <Spacer size="lg" />
              <div className="more__customer-button">
                <a
                  target={consumerLinkTarget}
                  className="button large ghost green"
                  href={consumerLinkUrl}
                >
                  {consumerLinkTitle}
                </a>
              </div>
              <Spacer size="lg" />
            </Col>
            <Col
              xs={{
                offset: 0,
                span: 24,
              }}
              sm={{ offset: 0, span: 12 }}
              md={{
                offset: 0,
                span: 24,
              }}
              className="more__customer more__customer--pro"
            >
              <Spacer size="md" />
              <h2 className="more__customer-headline">
                {professionalHeadline}
              </h2>
              <Spacer size="md" />
              <h3 className="more__customer-heading">{professionalHeading}</h3>
              <Spacer size="sm" />
              <p className="more__customer-body">{professionalBody}</p>
              <Spacer size="lg" />
              <div className="more__customer-button">
                <a
                  target={professionalLinkTarget}
                  className="button large gray"
                  href={professionalLinkUrl}
                >
                  {professionalLinkTitle}
                </a>
              </div>
              <Spacer size="lg" />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

MoreContent.propTypes = {
  more_content_headline: PropTypes.string.isRequired,
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        srcset: PropTypes.string.isRequired,
        placeholder: PropTypes.string.isRequired,
        placeholderBase64: PropTypes.string.isRequired,
        base64: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        alt: PropTypes.string.isRequired,
      }).isRequired,
      title: PropTypes.string.isRequired,
      excerpt: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      categories: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  cta_heading: PropTypes.string.isRequired,
  cta_body: PropTypes.string.isRequired,
  cta_link: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }).isRequired,
  consumer_headline: PropTypes.string.isRequired,
  consumer_heading: PropTypes.string.isRequired,
  consumer_body: PropTypes.string.isRequired,
  consumer_link: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }).isRequired,
  professional_headline: PropTypes.string.isRequired,
  professional_heading: PropTypes.string.isRequired,
  professional_body: PropTypes.string.isRequired,
  professional_link: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }).isRequired,
};

export default MoreContent;
